<template>
  <div v-if="grupo">
    <div class="hero-image" :style="{ backgroundImage: `url('${grupo.viaje.imagenExperiencia}')` }"></div>
    <div class="proximas-reservas-detalle detalle-page bg-white text-primary">
      <div class="layout detalle-layout d-flex align-items-start gap-20">
        <aside v-if="!isMobileView" class="sidebar detalle-sidebar">
          <TabsComponent
            :tabs="reservaTabs"
            :initial-tab="activeTab"
            :mode="TABS_MODE.SCROLL"
            :layout="TABS_LAYOUT.VERTICAL"
            @tab-changed="handleTabChange" />
        </aside>
        <div class="contenido detalle-content">
          <div class="contenedor detalle-container">
            <div :class="isMobileView ? 'mb-m-25' : 'mb-30'">
              <div class="detalle-header d-flex align-items-center pointer mb-10" @click="doVolver">
                <CustomIcon :icon="leftIcon" size="16px" class="text-primary flex-shrink-0 me-2" />
                <span class="text-primary semibold h6 mb-0">
                  {{ $t('baseMigas.datosReservaDe', { nombre: nombreTitular }) }}
                </span>
              </div>

              <span class="p text-primary w-100">
                {{ $t('reserva.controlTotalDescripcion') }}
              </span>
            </div>

            <div class="row pb-none mx-0">
              <section id="section-personas" class="col-12 section-content px-0" :class="{ 'px-0': isMobileView }">
                <div class="col-12">
                  <div
                    v-if="ocupantes.length > 0"
                    class="contenedor-occupancy justify-content-start py-12 px-15"
                    :class="{ 'contenedor-occupancy--scroll': isMobileView }">
                    <CardOccupancyMini
                      :max-size="grupo.habitacion ? grupo.habitacion.numPlazas : -1"
                      :occupants-info="ocupantes" />
                  </div>

                  <CardReservaPlazasLibres
                    v-if="hasPlazasLibres"
                    class="mt-2"
                    :plazas-libres="cantidadPlazasLibres"
                    :pago-pendiente="totalPendientePlazaLibre"
                    :fecha-cancelacion="fechaLimiteToFillRoom"
                    :suplemento-pagado="hasPlazasLibres && grupo.habitacion.plazasLibresRepercutidas"
                    :viaje="grupo.viaje"
                    :codigo-grupo="grupo.codigo"
                    :is-b2b="grupo.isB2b"
                    @abonar-pago="handlerAbonarPagoPendiente" />

                  <div v-if="!grupo.isB2b" id="section-documentacion" class="mt-35 mt-m-30">
                    <div class="mb-3 h6 semibold">
                      {{ $t('reserva.documentacionExperiencia') }}
                    </div>
                    <div class="doc-exp-panel p-20 p-m-15">
                      <div class="d-flex align-items-center mb-10">
                        <CustomIcon :icon="grupoIcon" size="16px" class="text-primary flex-shrink-0 mr-15" />
                        <span class="p medium text-primary">{{ $t('reserva.documentacionGeneral') }}</span>
                      </div>
                      <div class="row g-2">
                        <div class="col-12 col-md-6">
                          <div
                            class="doc-exp-item w-100 px-15 py-10 d-flex align-items-center justify-content-between pointer"
                            :class="{ 'doc-exp-item--disabled': isLoadingReciboResumen }"
                            @click="descargarReciboResumen">
                            <div class="d-flex align-items-center min-w-0 flex-grow-1">
                              <template v-if="isLoadingReciboResumen">
                                <div
                                  class="spinner-border spinner-border-sm text-primary mr-15 flex-shrink-0"
                                  role="status" />
                                <span class="p medium text-primary text-truncate">{{ msgLoadingReciboResumen }}</span>
                              </template>
                              <template v-else>
                                <CustomIcon
                                  :icon="documentoIcon"
                                  size="16px"
                                  class="text-primary flex-shrink-0 mr-15" />
                                <span class="p medium text-primary">{{ $t('botones.resumen') }}</span>
                              </template>
                            </div>
                            <CustomIcon
                              v-if="!isLoadingReciboResumen"
                              :icon="descargarIcon"
                              size="16px"
                              class="text-primary flex-shrink-0" />
                          </div>
                        </div>
                        <div v-if="mostrarBonoDocumentacion" class="col-12 col-md-6">
                          <div
                            class="doc-exp-item w-100 px-15 py-10 d-flex align-items-center justify-content-between pointer"
                            @click="handlerBonoDocumentacion">
                            <div class="d-flex align-items-center min-w-0 flex-grow-1">
                              <CustomIcon
                                :icon="scanBarcodeIcon"
                                size="16px"
                                class="text-primary flex-shrink-0 mr-15" />
                              <span class="p medium text-primary">{{ $t('botones.verBono') }}</span>
                            </div>
                            <CustomIcon :icon="descargarIcon" size="16px" class="text-primary flex-shrink-0" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="grupo.isB2b" class="mb-2 mt-3">
                    <MyGocuButton secondary :label="t('botones.importarReservas')" @click="goImportarReservas" />
                    <div v-if="importacionesReserva.length > 0" class="tabla-importaciones rounded-12 mt-3">
                      <div class="tabla-importaciones-scroll">
                        <div class="tabla-importaciones-lista w-100">
                          <div
                            v-for="importacion in importacionesReserva"
                            :key="importacion.uuid"
                            class="tabla-importaciones-fila d-flex align-items-center w-100 pointer p-15"
                            @click="goVerImportacion(importacion)">
                            <div class="tabla-importaciones-contenido-scroll">
                              <div class="tabla-importaciones-contenido-inner d-flex flex-row align-items-center w-100">
                                <div class="tabla-importaciones-archivo d-flex align-items-center semibold">
                                  <span
                                    class="tabla-importaciones-archivo-nombre text-primary small medium text-truncate"
                                    >{{ importacion.file?.nombre }}</span
                                  >
                                  <span
                                    class="tabla-importaciones-estado d-flex align-items-center justify-content-center medium small"
                                    :class="getImportacionEstadoClass(importacion.estado)">
                                    {{ getImportacionEstadoLabel(importacion.estado) }}
                                  </span>
                                </div>
                                <div
                                  class="tabla-importaciones-resumen d-flex align-items-center justify-content-start">
                                  <span class="sub color-reservas-importadas">
                                    {{ $t('reserva.importacionesReserva.reservasImportadas') }}
                                  </span>
                                  <span class="small text-primary">
                                    {{ importacion.numRegistrosCompleted }}
                                  </span>
                                  <span
                                    v-if="
                                      importacion.estado !== IMPORTACION_RESERVA_ESTADO.PENDING &&
                                      Math.max(importacion.numRegistros - importacion.numRegistrosCompleted, 0) > 0
                                    "
                                    class="small text-rojo-500 ms-1">
                                    ({{
                                      t('reserva.importacionesReserva.reservasFallidas', {
                                        cantidad: Math.max(
                                          importacion.numRegistros - importacion.numRegistrosCompleted,
                                          0
                                        ),
                                      })
                                    }})
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div
                              class="tabla-importaciones-acciones d-flex flex-shrink-0 justify-content-end align-items-center"
                              @click.stop>
                              <button
                                type="button"
                                class="tabla-importaciones-acciones-trigger d-flex align-items-center justify-content-center border-0 p-0 bg-transparent"
                                @click.stop="toggleImportacionDropdown(importacion.uuid)">
                                <CustomIcon
                                  :icon="tresPuntosIcon"
                                  size="21px"
                                  class="text-primary tabla-importaciones-acciones-btn" />
                              </button>
                              <div
                                v-if="activeImportacionDropdownUuid === importacion.uuid"
                                class="tabla-importaciones-dropdown"
                                @click.stop>
                                <button
                                  type="button"
                                  class="tabla-importaciones-dropdown-item w-100 text-start medium small"
                                  @click.stop="goVerImportacion(importacion)">
                                  {{
                                    importacion.estado === IMPORTACION_RESERVA_ESTADO.COMPLETED
                                      ? $t('ver')
                                      : $t('editar')
                                  }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section
                v-if="grupo.viaje?.observaciones"
                id="section-informacion"
                class="col-12 section-content mt-35 mt-m-25 p-0">
                <div class="mb-3 h6 semibold">
                  {{ $t('reserva.superGrupo.informacionViaje') }}
                </div>
                <div class="info-exp-caja p-20">
                  <div class="info-exp-texto text-primary" :class="{ abierto: observacionesExpanded }">
                    <div
                      ref="observacionesContenidoEl"
                      v-sanitize-html="grupo.viaje.observaciones"
                      class="info-exp-contenido"></div>
                  </div>
                  <div class="d-flex justify-content-start">
                    <span
                      v-if="mostrarVerMasObservaciones"
                      class="info-exp-vermas p text-primary pointer d-inline-flex align-items-center"
                      @click.stop="toggleObservaciones">
                      <CustomIcon
                        :icon="observacionesExpanded ? plegarIcon : desplegarIcon"
                        size="16px"
                        class="text-primary flex-shrink-0 me-2" />
                      {{ observacionesExpanded ? $t('general.verMenos') : $t('general.verMas') }}
                    </span>
                  </div>
                </div>
              </section>

              <section id="section-resumen" class="col-12 section-content mt-35 mt-m-25 p-0">
                <div>
                  <div>
                    <div class="mb-3 h6 semibold">
                      {{ $t('reserva.tabs.resumen') }}
                    </div>
                    <CardInfoExperiencia :is-b2b="grupo.isB2b" is-mis-reservas />
                  </div>

                  <CardInfoInvitacionGrupoAsReserva v-if="grupo.isB2b" :grupo-cerrado="grupo" />
                  <CardInfoReserva v-else is-mis-reservas @recuperar-reserva="showModalRecuperar = true" />

                  <ModalQrReserva
                    :grupo="grupo"
                    :modal-active="showModalQrReserva"
                    @close-modal="showModalQrReserva = false" />
                </div>

                <div class="acciones-reserva detalle-actions mt-15">
                  <div class="acciones-fila detalle-actions-row d-flex align-items-center justify-content-end gap-10">
                    <MyGocuButton
                      v-if="!grupo.isB2b && isEnabledModificar() && moreOfAnActiveReservation"
                      tertiary
                      :prefix-icon="cerrarIcon"
                      :label="$t('botones.cancelarReserva')"
                      @click="showModalCancelar = true" />
                    <MyGocuButton
                      v-if="!grupo.isB2b && isEnabledModificar() && moreOfAnActiveReservation"
                      secondary
                      :label="$t('botones.modificarReserva')"
                      @click="goToModificarReserva" />
                  </div>
                </div>
                <!-- Sección Informacion de transporte -->
                <template v-if="buses && Object.keys(buses).length !== 0">
                  <div class="col-12 mb-15 h6 semibold">
                    {{ $t('reserva.superGrupo.informacionTransporte') }}
                  </div>
                  <div class="col-12">
                    <div class="tabla-pagos gx-0 p-12 p sub-m">
                      <table>
                        <thead class="small-m">
                          <tr>
                            <th class="medium p">{{ $t('reserva.buses.nombre') }}</th>
                            <th class="p">{{ $t('reserva.buses.horaSalidaIda') }}</th>
                            <th class="p">{{ $t('reserva.buses.lugarSalidaIda') }}</th>
                            <th class="p">{{ $t('reserva.buses.horaSalidaVuelta') }}</th>
                            <th class="p">{{ $t('reserva.buses.lugarSalidaVuelta') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(bus, idx) in buses" :key="idx">
                            <td>
                              {{ bus.nombre }}
                              <template v-for="(nombre, idx1) in bus.pasajeros" :key="idx1">
                                <div class="small pl-10 fw-normal">
                                  {{ nombre }}
                                </div>
                              </template>
                            </td>
                            <td>{{ bus.horaSalidaIda }}</td>
                            <td>{{ bus.lugarSalidaIda }}</td>
                            <td>{{ bus.horaSalidaVuelta }}</td>
                            <td>{{ bus.lugarSalidaVuelta }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </template>
              </section>

              <section
                v-if="grupo.viaje.termsConditions"
                id="section-terminos"
                class="col-12 section-content mt-35 mt-m-25 p-0">
                <div class="mb-3 h6 semibold">
                  {{ $t('seo.terminosCondiciones.title') }}
                </div>
                <div class="terms-block">
                  <div
                    class="title-rectangle d-flex justify-content-between align-items-center w-100 py-10 px-20 rounded-12">
                    <div class="semibold p text-primary">
                      {{ $t('general.terminosCondiciones') }} {{ agenciaStore.nombre }}
                    </div>
                    <MyGocuButton
                      secondary
                      :prefix-icon="openExternalIcon"
                      additional-class="flex-shrink-0"
                      @click="goToTerminosCondiciones" />
                  </div>
                </div>
              </section>

              <!-- Información de pago -->
              <section
                v-if="!grupo.isB2b && !isInscripcion"
                id="section-estado"
                class="col-12 section-content mt-35 mt-m-25 p-0">
                <div class="col-12 mb-15 h6 semibold">
                  {{ $t('reserva.informacionPago') }}
                </div>
                <div v-if="totalPendiente > 0" class="col-12 small mb-15">
                  {{
                    $t('reserva.msjNoPagos', {
                      pendientePago: formatPrice(totalPendiente),
                      currency: agenciaStore.getCurrency,
                    })
                  }}
                </div>

                <div v-if="hitosPagados.length > 0" class="pago-seccion rounded-12 mb-15 p-20 p-m-10">
                  <div class="d-flex align-items-center">
                    <CustomIcon :icon="checkIcon" size="14px" class="mr-10" />
                    <span class="p medium text-primary">{{ $t('reserva.pagosRealizados') }}</span>
                  </div>
                  <div v-for="hito in hitosPagados" :key="'pagado-' + hito.numero" class="pago-item pl-30 pt-20 pl-m-0">
                    <div class="row align-items-lg-center align-items-start g-0 mx-0 pago-item-cabecera">
                      <div class="col-6 pago-item-izq d-flex align-items-lg-center align-items-start flex-wrap gap-10">
                        <span class="p text-primary pago-item-titulo">{{
                          $t('reserva.pagoNumero', { n: hito.numero })
                        }}</span>
                        <span class="pago-badge pago-item-estado bg-verde-100 text-verde-800 sub">{{
                          $t('general.pagado')
                        }}</span>
                      </div>
                      <div class="col-4 pago-item-fecha p small-m text-primary">
                        <span class="pago-item-fecha-label me-1">{{ $t('general.fecha') }}:</span>
                        <span class="pago-item-fecha-valor">{{ hito.fecha ? formatDate(hito.fecha) : '-' }}</span>
                      </div>
                      <div class="col-2 pago-item-importe p text-end text-verde-700">
                        {{ formatPrice(hito.importeResuelto) }} {{ agenciaStore.getCurrency }}
                      </div>
                    </div>
                    <div v-if="hito.personas?.length" class="small text-primary fw-normal mt-10 ml-m-10">
                      <div
                        v-for="(persona, nIdx) in hito.personas"
                        :key="nIdx"
                        class="d-flex align-items-center flex-wrap gap-10">
                        <span>{{ persona.nombre }}</span>
                        <button
                          v-if="persona.solicitudCobroId"
                          class="pago-item-recibo d-flex align-items-center pointer sub text-primary text-decoration-underline border-0 p-0 bg-transparent"
                          :disabled="loadingRecibos[persona.solicitudCobroId]"
                          @click="descargarReciboPago(persona.solicitudCobroId)">
                          <template v-if="loadingRecibos[persona.solicitudCobroId]">
                            <div class="spinner-border spinner-border-sm text-primary me-1" role="status" />
                            {{ msgLoadingRecibos[persona.solicitudCobroId] }}
                          </template>
                          <template v-else>
                            {{ $t('reserva.descargarRecibo') }}
                            <CustomIcon :icon="descargarIcon" size="12px" class="ms-1" />
                          </template>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="hitosPendientes.length > 0 || (hasPlazasLibres && !grupo.habitacion.plazasLibresRepercutidas)"
                  class="pago-seccion rounded-12 p-20 p-m-10">
                  <div class="d-flex align-items-center">
                    <CustomIcon :icon="relojIcon" size="14px" class="mr-10" />
                    <span class="p medium text-primary">{{ $t('reserva.pagosPendientes') }}</span>
                  </div>
                  <div
                    v-for="hito in hitosPendientes"
                    :key="'pendiente-' + hito.numero"
                    class="pago-item pl-30 pl-m-0 pt-20">
                    <div class="row align-items-lg-center align-items-start g-0 mx-0 pago-item-cabecera">
                      <div class="col-6 pago-item-izq d-flex align-items-lg-center align-items-start flex-wrap gap-10">
                        <span class="p text-primary pago-item-titulo">{{
                          $t('reserva.pagoNumero', { n: hito.numero })
                        }}</span>
                        <span class="pago-badge pago-item-estado bg-rojo-100 text-rojo-600 sub">{{
                          $t('general.pendiente')
                        }}</span>
                      </div>
                      <div class="col-4 pago-item-fecha p small-m text-primary">
                        <span class="pago-item-fecha-label me-1">{{ $t('reserva.vencimiento') }}:</span>
                        <span class="pago-item-fecha-valor">{{ formatDate(hito.fechaVencimiento) }}</span>
                      </div>
                      <div class="col-2 pago-item-importe p text-end text-rojo-700">
                        {{ formatPrice(hito.importeResuelto) }} {{ agenciaStore.getCurrency }}
                      </div>
                    </div>
                    <div v-if="hito.nombres?.length" class="small text-primary fw-normal mt-10">
                      <div v-for="(nombre, nIdx) in hito.nombres" :key="nIdx">{{ nombre }}</div>
                    </div>
                  </div>

                  <div
                    v-if="hasPlazasLibres && !grupo.habitacion.plazasLibresRepercutidas"
                    class="pago-item pl-30 pl-m-0 pt-20">
                    <div class="row align-items-lg-center align-items-start g-0 mx-0 pago-item-cabecera">
                      <div class="col-6 pago-item-izq d-flex align-items-lg-center align-items-start flex-wrap gap-10">
                        <span class="p text-primary pago-item-titulo">{{ $t('cardReservaPlazasLibres.titulo') }}</span>
                        <span class="pago-badge pago-item-estado bg-rojo-100 text-rojo-600 sub">{{
                          $t('general.pendiente')
                        }}</span>
                      </div>
                      <div class="col-4 pago-item-fecha p small-m text-primary">
                        <span class="pago-item-fecha-label me-1">{{ $t('reserva.vencimiento') }}:</span>
                        <span class="pago-item-fecha-valor">{{ formatDate(fechaLimiteToFillRoom) }}</span>
                      </div>
                      <div class="col-2 pago-item-importe p text-end text-rojo-700">
                        {{ formatPrice(totalPendientePlazaLibre) }} {{ agenciaStore.getCurrency }}
                      </div>
                    </div>
                    <div class="d-flex align-items-center small text-primary mt-10">
                      <CustomIcon :icon="plazaLibreIcon" size="24px" class="mr-10" />
                      <span>{{ cantidadPlazasLibres }} x {{ $t('cardReservaPlazasLibres.plazasLibres') }}</span>
                    </div>
                  </div>
                </div>

                <div
                  v-if="totalPendiente > 0 && !grupo.viaje.buscador"
                  class="detalle-gestionar-pago col-12 p-20 p-m-15 d-flex align-items-center pointer text-primary mt-20"
                  @click="abrirModalPagar">
                  <CustomIcon :icon="monedasIcon" size="14px" class="flex-shrink-0 mr-20" />
                  <span class="p medium flex-grow-1 text-start">{{ $t('reserva.gestionarPago') }}</span>
                  <CustomIcon :icon="derechaIcon" size="16px" class="flex-shrink-0 mx-1 mx-md-3" />
                </div>
              </section>

              <section
                v-if="!grupo.isB2b && !grupo.viaje.buscador && formulariosInscripcion.length > 0"
                id="section-checkin"
                class="col-12 section-content mt-35 mt-m-25 p-0">
                <div class="col-12 mb-15 h6 semibold">
                  {{ $t('reserva.tabs.formularioInscripcion') }}
                </div>
                <FormularioInscripcionCard
                  v-for="formulario in formulariosInscripcion"
                  :key="formulario.id"
                  class="mb-4"
                  :formulario="{ ...formulario, grupoId }"
                  @formulario-enviado="loadFormulariosInscripcion" />
              </section>

              <section v-if="!grupo.isB2b" id="section-comunidad" class="col-12 section-content mt-35 mt-m-25 p-0">
                <div class="col-12 mb-3 h6 semibold">
                  {{ $t('reserva.tabs.comunidad') }}
                </div>
                <div class="col-12">
                  <div class="texto-sub gx-0 p small-m">
                    <div v-if="!grupo.superGrupo" class="mb-4 p">
                      <span>{{ $t('reserva.comunidad.descripcion') }}</span>
                      <div class="text-center mb-5 mt-4">
                        <MyGocuButton primary :label="$t('reserva.comunidad.boton')" @click="crearComunidad" />
                      </div>
                    </div>
                    <ComunidadCard v-else :grupo="grupo" @eliminar="eliminarComunidad" @copiar-codigo="copiarCodigo" />
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <ModalPagarReserva :grupo="grupo" :modal-active="showModalPagar" @close-modal="showModalPagar = false" />

      <ModalRecuperacionReserva
        :grupo="grupo"
        :modal-active="showModalRecuperar"
        @close-modal="showModalRecuperar = false" />

      <ModalCancelarReserva :grupo="grupo" :modal-active="showModalCancelar" @close-modal="showModalCancelar = false" />

      <template v-if="grupo.habitacion">
        <ModalConfirmacionPlazasLibres
          :show="showModalPlazasLibres"
          :plazas-libres="cantidadPlazasLibres"
          :precio-total="totalPendientePlazaLibre"
          @on-close="showModalPlazasLibres = false"
          @on-cancel="handlerAnadirSuplemento"
          @on-submit="handlerGentePorReservar" />
      </template>

      <ModalCrearComunidad
        :modal-active="showModalCrearComunidad"
        @close-modal="showModalCrearComunidad = false"
        @crear-comunidad="handleCrearComunidad" />

      <ModalConfirmacion
        :modal-active="showModalEliminarComunidad"
        :title="t('reserva.comunidad.confirmarEliminar')"
        :message="t('reserva.comunidad.noRecuperar')"
        :confirm-text="t('actions.delete')"
        :cancel-text="t('general.no')"
        @close-modal="showModalEliminarComunidad = false"
        @confirm="confirmarEliminarComunidad" />
    </div>
  </div>
</template>

<script setup>
  import { useRoute, useRouter } from 'vue-router';
  import { ref, computed, onBeforeMount, onUnmounted } from 'vue';
  import { proximasExperiencias } from '@/store_pinia/proximasExperiencias';
  import { createToaster } from '@meforma/vue-toaster';
  import ReservasApiService from '@/services/api/ReservasApiService';
  import ViajesGrupoApiService from '@/services/api/ViajesGrupoApiService';
  import ModalPagarReserva from 'src/components/modales/Reserva/ModalPagarReserva.vue';
  import CardOccupancyMini from '@/modules/viajesGrupos/components/CardOccupancyMini.vue';
  import ModalRecuperacionReserva from '@/components/modales/Reserva/ModalRecuperacionReserva';
  import ModalCancelarReserva from '@/components/modales/Reserva/ModalCancelarReserva.vue';
  import ModalConfirmacionPlazasLibres from '@/components/modales/viajesGrupo/ModalConfirmacionPlazasLibres.vue';
  import CardReservaPlazasLibres from '@/components/card/Reserva/CardReservaPlazasLibres.vue';
  import { occupantsNotManagedReservations, occupantsManagedReservations } from '@/services/utils/GrupoUtils';
  import { ESTADOS_RESERVA } from '@/constants/reservaConstants';
  import { ESTADOS_PETICION } from '@/constants/petitionConstants';
  import CardInfoExperiencia from '@/components/card/Reserva/CardInfoExperiencia.vue';
  import CardInfoReserva from '@/components/card/Reserva/CardInfoReserva.vue';
  import CardInfoInvitacionGrupoAsReserva from '@/components/card/Reserva/CardInfoInvitacionGrupoAsReserva.vue';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import ModalQrReserva from '@/components/modales/Reserva/ModalQrReserva.vue';
  import MyGocuButton from '@/components/common/buttons/MyGocuButton.vue';
  import openExternalIcon from '@/assets/icons/open-external.svg';
  import monedasIcon from '@/assets/icons/raw/monedas.svg';
  import derechaIcon from '@/assets/icons/raw/derecha.svg';
  import { calculateTotalPendiente } from '@/services/utils/GrupoUtils';
  import { calculaHitosPago, syncHitosWithPagos, ordenarHitosPago } from '@/helpers/hitosPagoUtils';
  import { useI18n } from 'vue-i18n';
  import { UsuarioProximaReservasModificar, UsuarioProximasReservas } from '@/router/RouterNames';
  import FormularioInscripcionCard from '@/modules/viajesGrupos/components/FormularioInscripcionCard.vue';
  import moment from 'moment-timezone';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import { toRawDeep } from '@/helpers/reactivityUtils';
  import TabsComponent from '@/components/tabs/TabsComponent.vue';
  import { TABS_LAYOUT, TABS_MODE } from '@/helpers/tabsUtils';
  import ModalCrearComunidad from '@/components/comunidad/ModalCrearComunidad.vue';
  import ModalConfirmacion from '@/components/modales/ModalConfirmacion.vue';
  import ComunidadCard from '@/components/comunidad/ComunidadCard.vue';
  import { formatDate } from '@/helpers/dateUtiles';
  import { ESTADOS_INVITACION_GRUPO, TIPOS_PAGO } from '@/constants/viajeConstants';
  import { formatPrice } from '@/helpers/numberUtils';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import currency from 'currency.js';
  import CustomIcon from '@/components/CustomIcon.vue';
  import tresPuntosIcon from '@/assets/icons/raw/tres-puntos.svg';
  import { useUserStore } from '@/store_pinia/userStore';
  import { IMPORTACION_RESERVA_ESTADO } from '@/services/utils/importacionReservasUtils';
  import { MYGOCU_ADMIN } from '@/helpers/domainUtils';
  import leftIcon from '@/assets/icons/raw/izquierda.svg';
  import grupoIcon from '@/assets/icons/raw/grupo.svg';
  import documentoIcon from '@/assets/icons/raw/documento.svg';
  import descargarIcon from '@/assets/icons/raw/descargar.svg';
  import scanBarcodeIcon from '@/assets/icons/raw/scan-barcode.svg';
  import checkIcon from '@/assets/icons/raw/check.svg';
  import relojIcon from '@/assets/icons/raw/reloj.svg';
  import cerrarIcon from '@/assets/icons/raw/cerrar.svg';
  import plazaLibreIcon from '@/assets/icons/raw/plaza-libre.svg';
  import desplegarIcon from '@/assets/icons/raw/desplegar.svg';
  import plegarIcon from '@/assets/icons/raw/plegar.svg';

  const route = useRoute();
  const router = useRouter();
  const storeProxExp = proximasExperiencias();
  const storeHabitacion = informacionHabitacion();
  const agenciaStore = agenciaStoreModule();
  const loadingStore = useLoadingStore();
  const authStore = useUserStore();
  const loadingRecibos = ref({});
  const msgLoadingRecibos = ref({});
  const isLoadingReciboResumen = ref(false);
  const msgLoadingReciboResumen = ref('');
  const showModalRecuperar = ref(false);
  const showModalPagar = ref(false);
  const showModalCancelar = ref(false);
  const grupoId = route.params.grupoId;
  const grupo = ref();
  const buses = ref(null);
  const showModalQrReserva = ref(false);
  const showModalPlazasLibres = ref(false);
  const { t } = useI18n();
  const showModalEliminarComunidad = ref(false);
  const showModalCrearComunidad = ref(false);
  const toaster = createToaster({ position: 'top-right' });
  const viaje = computed(() => storeHabitacion.getViaje);

  const activeTab = ref('documentacion');

  const importacionesReserva = ref([]);
  const formulariosInscripcion = ref([]);
  const activeImportacionDropdownUuid = ref(null);
  const observacionesContenidoEl = ref(null);
  const observacionesExpanded = ref(false);
  const mostrarVerMasObservaciones = ref(false);

  function checkObservacionesHeight() {
    if (!observacionesContenidoEl.value) {
      mostrarVerMasObservaciones.value = false;
      return;
    }
    const heightContenido = Math.ceil(observacionesContenidoEl.value.getBoundingClientRect().height);
    mostrarVerMasObservaciones.value = heightContenido > 60;
  }

  function toggleObservaciones() {
    observacionesExpanded.value = !observacionesExpanded.value;
  }

  const reservaTabs = computed(() => {
    const tabs = [
      {
        id: 'documentacion',
        label: t('reserva.documentacionExperiencia'),
        active: !grupo.value.isB2b,
      },
      {
        id: 'informacion',
        label: t('reserva.superGrupo.informacionViaje'),
        active: !!grupo.value?.viaje?.observaciones,
      },
      { id: 'resumen', label: t('reserva.tabs.resumen'), active: true },
      {
        id: 'terminos',
        label: t('seo.terminosCondiciones.title'),
        active: !!grupo.value?.viaje?.termsConditions,
      },
      {
        id: 'estado',
        label: t('reserva.informacionPago'),
        active: !grupo.value.isB2b && !isInscripcion.value,
      },
      {
        id: 'checkin',
        label: t('reserva.tabs.formularioInscripcion'),
        active: !grupo.value.isB2b && !grupo.value.viaje.buscador && formulariosInscripcion.value.length > 0,
      },
      {
        id: 'comunidad',
        label: t('reserva.tabs.comunidad'),
        active: !grupo.value.isB2b,
      },
    ];

    return tabs.filter(tab => tab.active);
  });

  const fechaLimiteToFillRoom = computed(() => {
    if (!(hasPlazasLibres.value && !grupo.value.habitacion.plazasLibresRepercutidas)) return null;
    let fechaLimite = moment(grupo.value.viaje.fechaLimitePago);
    if (grupo.value.viaje.daysToFillRoom > 0) {
      const fechaLimiteToFill = moment(grupo.value.habitacion.fechaCreacion).add(
        grupo.value.viaje.daysToFillRoom,
        'days'
      );
      fechaLimite = fechaLimite.isBefore(fechaLimiteToFill) ? fechaLimite : fechaLimiteToFill;
    }
    return fechaLimite.format('YYYY-MM-DD');
  });

  const isMobileView = ref(window.innerWidth <= 768);

  const nombreTitular = computed(() =>
    grupo.value?.reservas?.length > 0
      ? grupo.value.reservas[0].nombreUsuario
      : grupo.value?.nombre
      ? grupo.value.nombre
      : ''
  );

  function handleResize() {
    isMobileView.value = window.innerWidth <= 768;
    checkObservacionesHeight();
  }
  const isInscripcion = computed(
    () =>
      grupo.value.viaje.tipoPago === TIPOS_PAGO.SIN_PAGO ||
      grupo.value.viaje.invitacionGrupo?.estado === ESTADOS_INVITACION_GRUPO.ACEPTADA
  );
  const moreOfAnActiveReservation = computed(
    () => grupo.value.reservas.filter(reserva => reserva.estado !== ESTADOS_RESERVA.CANCELADA).length >= 1
  );

  const hasPlazasLibres = computed(
    () =>
      !grupo.value.isB2b &&
      grupo.value.habitacion &&
      grupo.value.habitacion.plazasLibresEnabled &&
      moreOfAnActiveReservation.value &&
      grupo.value.habitacion.numPlazas - ocupantes.value.length > 0
  );

  const totalPendiente = computed(() =>
    grupo.value.isB2b
      ? currency(grupo.value.viaje.invitacionGrupo.importeTotalEstimado)
      : calculateTotalPendiente(grupo.value.reservas)
  );

  const resumenReservas = computed(() => storeHabitacion.getResumenReservas);

  const hasBonoAdjunto = computed(() => resumenReservas.value[0]?.hasBonoAdjunto);

  const showQrBono = computed(() => {
    if (!resumenReservas.value?.length) return false;
    const isNotCancelled = resumenReservas.value.some(({ estado }) => estado !== ESTADOS_RESERVA.CANCELADA);
    return isNotCancelled && totalPendiente.value <= 0;
  });

  const mostrarBonoDocumentacion = computed(() => showQrBono.value || hasBonoAdjunto.value);

  const ocupantes = computed(() => {
    const ocupantesNoGestionados = occupantsNotManagedReservations(grupo.value);
    const ocupantesGestionados = occupantsManagedReservations(grupo.value);

    return [...ocupantesNoGestionados, ...ocupantesGestionados].map(ocupante => ({
      nombre: ocupante.nombre,
      apellido: ocupante.apellido,
      done: ocupante.done,
    }));
  });

  const totalPendientePlazaLibre = computed(() => {
    if (grupo.value.habitacion) {
      return (
        (grupo.value.habitacion.numPlazas - ocupantes.value.length) * grupo.value.habitacion.alojamiento.precioCamaVacia
      );
    } else {
      return 0;
    }
  });

  const cantidadPlazasLibres = computed(() => {
    if (grupo.value.habitacion) {
      return grupo.value.habitacion.numPlazas - ocupantes.value.length;
    } else {
      return 0;
    }
  });

  function toHitoRow(hito, atrib, idx, importeResuelto = hito.cantidad.value) {
    return {
      numero: idx + 1,
      importeResuelto,
      fecha: atrib.fechasPago.length
        ? atrib.fechasPago.reduce(
            (maxFecha, f) => (moment(f).isAfter(moment(maxFecha)) ? f : maxFecha),
            atrib.fechasPago[0]
          )
        : null,
      fechaVencimiento: hito.fecha,
      nombres: atrib.personasPendientes ?? [],
    };
  }

  function getHitosPagados(hitosConPagos) {
    return hitosConPagos
      .map(hitoConPagos => {
        const personas = hitoConPagos.personasPagadas.map(({ nombre, solicitudCobroId }) => ({
          nombre,
          solicitudCobroId,
        }));
        const fechas = hitoConPagos.personasPagadas.map(persona => persona.fecha).filter(Boolean);

        return {
          numero: hitoConPagos.numero,
          importeResuelto: hitoConPagos.personasPagadas.reduce(
            (total, persona) => total.add(persona.importe),
            currency(0)
          ).value,
          fecha: fechas.length
            ? fechas.reduce((maxFecha, fecha) => (moment(fecha).isAfter(maxFecha) ? fecha : maxFecha))
            : null,
          personas,
        };
      })
      .filter(pago => pago.personas.length > 0);
  }

  const hitosProcesados = computed(() => {
    if (!resumenReservas.value?.length) return { pagados: [], pendientes: [] };

    return procesarHitosPago(grupo.value?.viaje?.hitosPago, resumenReservas.value, grupo.value?.viaje);
  });

  const hitosPagados = computed(() => hitosProcesados.value.pagados);

  const hitosPendientes = computed(() => {
    if (totalPendiente.value <= 0) return [];
    return hitosProcesados.value.pendientes;
  });

  function buildPagoRealizado(activas, i) {
    const pagosActuales = activas.map(reserva => reserva.pagos?.[i]).filter(Boolean);
    const fechas = pagosActuales.map(pago => pago.fecha).filter(Boolean);
    return {
      numero: i + 1,
      importeResuelto: pagosActuales.reduce((total, pago) => total.add(pago.cantidad), currency(0)).value,
      fecha: fechas.length
        ? fechas.reduce((maxFecha, fecha) => (moment(fecha).isAfter(maxFecha) ? fecha : maxFecha))
        : null,
      fechaVencimiento: null,
      personas: activas
        .filter(reserva => reserva.pagos?.[i])
        .map(reserva => ({
          nombre: reserva.nombreUsuario,
          solicitudCobroId: reserva.pagos[i].id ?? null,
        })),
    };
  }

  function procesarHitosPago(hitosPago, reservas, viaje) {
    const activas = reservas.filter(reserva => reserva.estado !== ESTADOS_RESERVA.CANCELADA);

    if (!hitosPago?.length) {
      const maxPagos = Math.max(0, ...activas.map(reserva => reserva.pagos?.length ?? 0));
      const pagados = Array.from({ length: maxPagos }, (_, i) => buildPagoRealizado(activas, i)).filter(
        pago => pago.personas.length > 0
      );
      return { pagados, pendientes: [] };
    }

    const hitosOrdenados = ordenarHitosPago(hitosPago, viaje);
    const { hitosPagoFinales, pendientes: hitosPendientes } = calculaHitosPago(hitosOrdenados, activas, viaje);
    const { hitosConPagos } = syncHitosWithPagos(hitosOrdenados, reservas, viaje);
    let pagados = getHitosPagados(hitosConPagos);

    if (pagados.length === 0) {
      const maxPagos = Math.max(0, ...activas.map(reserva => reserva.pagos?.length ?? 0));
      if (maxPagos > 0) {
        pagados = Array.from({ length: maxPagos }, (_, i) => buildPagoRealizado(activas, i)).filter(
          pago => pago.personas.length > 0
        );
      }
    }

    return {
      pagados,
      pendientes: hitosPendientes
        .map(hito => {
          const idx = hitosPagoFinales.indexOf(hito);
          return toHitoRow(
            hito,
            hitosConPagos[idx] ?? { fechasPago: [], personasPendientes: [] },
            idx,
            hito.cantidadPendiente.value
          );
        })
        .filter(hito => hito.nombres.length > 0),
    };
  }

  function handleTabChange(tabId) {
    activeTab.value = tabId;
  }

  function getImportacionEstadoClass(estado) {
    if (estado === IMPORTACION_RESERVA_ESTADO.COMPLETED || estado === IMPORTACION_RESERVA_ESTADO.PARTIALLY_COMPLETED) {
      return 'bg-verde-200 text-verde-700';
    }
    return 'bg-amarillo-400 text-amarillo-700';
  }

  function getImportacionEstadoLabel(estado) {
    if (estado === IMPORTACION_RESERVA_ESTADO.COMPLETED) {
      return t('reserva.importacionesReserva.estado.completada');
    }
    if (estado === IMPORTACION_RESERVA_ESTADO.PARTIALLY_COMPLETED) {
      return t('reserva.importacionesReserva.estado.completadaParcial');
    }
    return t('reserva.importacionesReserva.estado.pendiente');
  }

  function toggleImportacionDropdown(importacionUuid) {
    activeImportacionDropdownUuid.value =
      activeImportacionDropdownUuid.value === importacionUuid ? null : importacionUuid;
  }

  function closeImportacionDropdown() {
    activeImportacionDropdownUuid.value = null;
  }

  function doVolver() {
    router.push({
      name: UsuarioProximasReservas,
    });
  }

  async function loadFormulariosInscripcion() {
    if (grupo.value.isB2b || grupo.value.viaje.buscador) return;
    formulariosInscripcion.value = (await ReservasApiService.getFormularioInscripcion(grupoId)).formularios;
  }

  function goToModificarReserva() {
    router.push({
      name: UsuarioProximaReservasModificar,
    });
  }

  function goToTerminosCondiciones() {
    window.open(
      router.resolve({
        name: 'TerminosCondiciones',
        params: { viajeId: grupo.value.viaje.id },
        query: grupo.value.viaje.codigo ? { codigo: grupo.value.viaje.codigo } : {},
      }).href,
      '_blank'
    );
  }

  function goImportarReservas() {
    const url = new URL('/importarReservas', MYGOCU_ADMIN);
    url.searchParams.set('viajeUuid', viaje.value?.uuid);
    url.searchParams.set('usuarioUuid', authStore.getUsuario?.uuid);
    window.open(url.toString(), '_blank', 'noopener,noreferrer');
  }

  function goVerImportacion(importacion) {
    closeImportacionDropdown();
    const url = new URL('/importarReservas', MYGOCU_ADMIN);
    url.searchParams.set('viajeUuid', viaje.value?.uuid);
    url.searchParams.set('importacionUuid', importacion.uuid);
    window.open(url.toString(), '_blank', 'noopener,noreferrer');
  }

  function isEnabledModificar() {
    if (grupo.value?.viaje?.fechaInicio) {
      let date = new Date(grupo.value.viaje.fechaInicio);
      let today = new Date();
      return date > today;
    }
    return true;
  }

  async function handlerAbonarPagoPendiente() {
    try {
      loadingStore.show();
      await ReservasApiService.doForzarPlazasLibres(grupoId);
      await getInformacionGrupo(grupoId);
      await init();
      if (totalPendiente.value > 0) {
        abrirModalPagar();
      }
    } catch (error) {
      console.error(error);
      toaster.error(error);
    } finally {
      loadingStore.hide();
    }
  }

  async function getInformacionGrupo(grupoId) {
    try {
      loadingStore.show();
      await storeProxExp.setGrupoSeleccionado(grupoId, true, route.query.isB2b === 'true');
      grupo.value = storeProxExp.getGrupoSeleccionado;
      buses.value = !grupo.value.isB2b ? await ReservasApiService.getBusesGrupo(grupoId) : [];
    } catch (error) {
      console.error(error);
    } finally {
      loadingStore.hide();
    }
  }

  async function loadImportacionesReserva(viajeId, codigo, codigoPrevisualizacion) {
    try {
      loadingStore.show();
      importacionesReserva.value = await ViajesGrupoApiService.getImportarReservas(
        viajeId,
        codigo,
        codigoPrevisualizacion
      );
    } catch (error) {
      console.error(error);
      toaster.error(t('reserva.importacionesReserva.errorCarga'));
    } finally {
      loadingStore.hide();
    }
  }

  function abrirModalPagar() {
    if (hasPlazasLibres.value && !grupo.value.habitacion.plazasLibresRepercutidas) {
      showModalPlazasLibres.value = true;
    } else {
      showModalPagar.value = true;
    }
  }

  function handlerAnadirSuplemento() {
    showModalPlazasLibres.value = false;
    handlerAbonarPagoPendiente();
  }

  function handlerGentePorReservar() {
    showModalPlazasLibres.value = false;
    showModalPagar.value = true;
  }

  async function init() {
    try {
      loadingStore.show();
      await getInformacionGrupo(grupoId);
      storeHabitacion.clearReservas();
      const grupoRaw = toRawDeep(grupo.value);
      storeHabitacion.setInformacionAlojamientoFromRGrupoDTO(grupoRaw);
      if (grupoRaw.viaje && grupoRaw.viaje.id) {
        await storeHabitacion.loadInformacionViaje(
          grupoRaw.viaje.id,
          grupoRaw.viaje?.codigo ?? null,
          false,
          grupoRaw.viaje?.codigoPrevisualizacion ?? null
        );
        if (grupoRaw.isB2b) {
          await loadImportacionesReserva(grupoRaw.viaje.id, grupoRaw.viaje?.codigo, route.query.codigoPrevisualizacion);
        }
      }

      grupoRaw.reservas.map(reserva => {
        reserva.usuario = {
          nombre: reserva.nombre,
          apellidos: reserva.apellidos,
          apellido: reserva.apellidos,
          fechaNacimiento: reserva.fechaNacimiento,
        };
        storeHabitacion.addReserva(reserva);
      });
      await loadFormulariosInscripcion();
      activeTab.value = reservaTabs.value[0]?.id;
    } catch (error) {
      console.error(error);
    } finally {
      loadingStore.hide();
      checkObservacionesHeight();
    }
  }

  function crearComunidad() {
    showModalCrearComunidad.value = true;
  }

  async function handleCrearComunidad(nombre) {
    try {
      loadingStore.show();
      await ReservasApiService.doCrearSuperGrupo(grupoId, { nombre });
      toaster.success(t('reserva.comunidad.creacionExitosa'));
      showModalCrearComunidad.value = false;
      await getInformacionGrupo(grupoId);
    } catch (err) {
      toaster.error(err.response?.data?.message || t('reserva.comunidad.errorCrear'));
    } finally {
      loadingStore.hide();
    }
  }

  function copiarCodigo(codigo) {
    const dominioActual = window.location.origin;
    const url = `${dominioActual}/comunidad/${grupoId}/unirse/${codigo}`;

    navigator.clipboard
      .writeText(url)
      .then(() => {
        toaster.success(t('general.clipboard.success'));
      })
      .catch(() => {
        toaster.error(t('general.clipboard.error'));
      });
  }

  function eliminarComunidad() {
    showModalEliminarComunidad.value = true;
  }

  async function confirmarEliminarComunidad() {
    try {
      loadingStore.show();
      await ReservasApiService.doEliminarSuperGrupo(grupoId);
      toaster.success(t('reserva.comunidad.eliminacionExitosa'));
      await getInformacionGrupo(grupoId);
    } catch (err) {
      console.error(err);
      toaster.error(err.response?.data?.message || t('reserva.comunidad.errorEliminar'));
    } finally {
      loadingStore.hide();
    }
  }

  function handlerBonoDocumentacion() {
    if (hasBonoAdjunto.value) {
      descargarBonoAdjunto();
    } else if (showQrBono.value) {
      showModalQrReserva.value = true;
    }
  }

  async function descargarBonoAdjunto() {
    if (!hasBonoAdjunto.value || !resumenReservas.value[0]) return;

    try {
      loadingStore.show();
      const response = await ReservasApiService.getBonoAdjunto(grupoId, Number(resumenReservas.value[0].id));
      window.open(response, '_blank');
    } catch (error) {
      console.error('Error al descargar el PDF:', error);
    } finally {
      loadingStore.hide();
    }
  }

  async function descargarReciboResumen() {
    if (!resumenReservas.value[0] || isLoadingReciboResumen.value) return;

    try {
      isLoadingReciboResumen.value = true;
      msgLoadingReciboResumen.value = t('general.pendiente');

      let response;

      try {
        loadingStore.show();
        response = await ReservasApiService.getReciboResumen(grupoId, resumenReservas.value[0].id, true);
      } finally {
        loadingStore.hide();
      }

      if (response?.estado === ESTADOS_PETICION.PENDING || response?.estado === ESTADOS_PETICION.IN_PROGRESS) {
        let completed = false;
        while (!completed) {
          msgLoadingReciboResumen.value =
            response?.estado === ESTADOS_PETICION.PENDING ? t('general.pendiente') : t('general.ejecutando');

          await new Promise(resolve => setTimeout(resolve, 5000));

          const pollResponse = await ReservasApiService.getReciboResumen(grupoId, resumenReservas.value[0].id, false);

          if (pollResponse?.estado === ESTADOS_PETICION.COMPLETED && pollResponse?.url) {
            window.open(pollResponse.url, '_blank');
            completed = true;
          } else if (pollResponse?.estado === ESTADOS_PETICION.FAILED) {
            toaster.error(t('errors.generacion'));
            completed = true;
          }
        }
      } else if (response?.estado === ESTADOS_PETICION.COMPLETED && response?.url) {
        window.open(response.url, '_blank');
      } else if (response?.estado === ESTADOS_PETICION.FAILED) {
        toaster.error(t('errors.generacion'));
      }
    } catch (error) {
      console.error('Error al descargar el recibo:', error);
      toaster.error(t('errors.descarga'));
    } finally {
      isLoadingReciboResumen.value = false;
      msgLoadingReciboResumen.value = '';
    }
  }

  async function descargarReciboPago(solicitudCobroId) {
    try {
      if (!solicitudCobroId) {
        toaster.error(t('errors.generacion'));
        return;
      }

      loadingStore.show();
      loadingRecibos.value[solicitudCobroId] = true;
      msgLoadingRecibos.value[solicitudCobroId] = t('general.pendiente');

      const response = await ReservasApiService.getReciboPago(grupoId, solicitudCobroId, true);

      if (response?.estado === ESTADOS_PETICION.PENDING || response?.estado === ESTADOS_PETICION.IN_PROGRESS) {
        let completed = false;
        while (!completed) {
          msgLoadingRecibos.value[solicitudCobroId] =
            response?.estado === ESTADOS_PETICION.PENDING ? t('general.pendiente') : t('general.ejecutando');

          await new Promise(resolve => setTimeout(resolve, 5000));

          const pollResponse = await ReservasApiService.getReciboPago(grupoId, solicitudCobroId, false);

          if (pollResponse?.estado === ESTADOS_PETICION.COMPLETED && pollResponse?.url) {
            window.open(pollResponse.url, '_blank');
            completed = true;
          } else if (pollResponse?.estado === ESTADOS_PETICION.FAILED) {
            toaster.error(t('errors.generacion'));
            completed = true;
          }
        }
      } else if (response?.estado === ESTADOS_PETICION.COMPLETED && response?.url) {
        window.open(response.url, '_blank');
      }
    } catch (err) {
      console.error('Error al descargar recibo:', err);
      toaster.error(err.response?.data?.message || t('errors.generacion'));
    } finally {
      delete loadingRecibos.value[solicitudCobroId];
      delete msgLoadingRecibos.value[solicitudCobroId];
      loadingStore.hide();
    }
  }

  onBeforeMount(async () => {
    await init();
    window.addEventListener('resize', handleResize);
    document.addEventListener('click', closeImportacionDropdown);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
    document.removeEventListener('click', closeImportacionDropdown);
  });
</script>

<style lang="scss" scoped>
  .hero-image {
    width: 100vw;
    height: 290px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
  }

  .contenedor-occupancy {
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    border-radius: var(--bs-border-radius-xl);
  }

  .info-exp-caja {
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    border-radius: var(--bs-border-radius-lg);
  }

  .info-exp-texto {
    width: 100%;
    word-break: break-word;
    font-size: 16px;
    line-height: 1.5;
    max-height: 60px;
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;

    &.abierto {
      max-height: none;
    }

    .info-exp-contenido :deep(p) {
      margin-top: 0;
      margin-bottom: 0.5rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .info-exp-vermas {
    text-decoration: underline;
    margin-top: 8px;

    &:hover {
      color: rgba(var(--bs-primary-rgb), 0.8);
    }
  }

  .section-content {
    scroll-margin-top: 180px;
  }

  .detalle-page {
    min-height: 80vh;
    background-size: contain;
    background-position: top;

    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 0;
    box-sizing: border-box;
  }

  .detalle-sidebar {
    width: 290px;
    flex-shrink: 0;
    position: sticky;
    top: 120px;
    align-self: flex-start;
  }

  .detalle-content {
    flex: 1;
    max-width: 890px;
    min-width: 0;
    overflow-x: clip;
  }

  .detalle-container {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .detalle-content .row {
    max-width: 100%;
  }

  @media screen and (max-width: 768px) {
    .detalle-page {
      max-width: 100%;
      margin: 0;
      padding: 12vh 15px 2rem;
      overflow-x: clip;
      box-sizing: border-box;
    }

    .detalle-layout {
      display: block;
    }

    .detalle-content {
      width: 100%;
    }
  }

  @media screen and (max-width: 768px) {
    .detalle-container {
      margin: 0;
      padding: 0;
    }

    .contenedor-occupancy--scroll {
      overflow-x: auto;
      overflow-y: hidden;
      max-width: 100%;
      -webkit-overflow-scrolling: touch;

      :deep(.row-occupancy) {
        display: flex;
        flex-wrap: nowrap !important;
        width: max-content;
        min-width: 100%;
        overflow: visible;
        padding-bottom: 0;
      }

      :deep(.user-container) {
        width: auto !important;
        flex: 0 0 auto;
      }
    }

    .tabla-pagos {
      overflow-x: auto;
      max-width: 100%;
    }
  }

  @media (min-width: 576px) {
    .modal-dialog {
      max-width: 800px;
      margin: 1.75rem auto;
    }
  }

  .detalle-gestionar-pago {
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    border-radius: var(--bs-border-radius-xl);
  }

  .doc-exp-panel,
  .doc-exp-item {
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    border-radius: var(--bs-border-radius-xl);
  }

  .doc-exp-item--disabled {
    pointer-events: none;
    opacity: 0.6;
  }

  .tabla-pagos {
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    border-radius: var(--bs-border-radius-xl);

    table {
      width: 100%;
    }

    div {
      padding-bottom: 1rem;
      padding-right: 1rem;
    }

    th {
      border-bottom: 1px solid rgba(var(--bs-primary-rgb), 0.2);
      padding: 0.75rem;
      vertical-align: top;
    }

    td {
      padding: 0.6rem 0.4rem;
      vertical-align: top;
    }
  }

  .tabla-importaciones {
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    overflow: visible;

    .tabla-importaciones-scroll {
      overflow-x: visible;

      @media screen and (max-width: 768px) {
        overflow-x: auto;
        max-width: 100%;
        -webkit-overflow-scrolling: touch;
      }
    }

    .tabla-importaciones-fila {
      border-bottom: 1px solid rgba(var(--bs-primary-rgb), 0.2);

      &:last-child {
        border-bottom: 0;
      }
    }

    .tabla-importaciones-contenido-scroll {
      flex: 1;
      min-width: 0;
      overflow-x: visible;
    }

    .tabla-importaciones-contenido-inner {
      gap: 8px;
    }

    .tabla-importaciones-archivo {
      gap: 8px;
      padding-bottom: 0;
      padding-right: 0;
      color: var(--bs-primary);
      flex: 7 1 0;
      min-width: 0;
    }

    .tabla-importaciones-resumen {
      gap: 5px;
      flex: 4 1 0;
      min-width: 0;
    }

    .color-reservas-importadas {
      color: rgba(var(--bs-primary-rgb), 0.8);
    }

    .tabla-importaciones-estado {
      border-radius: 10px;
      padding: 2px 10px;
      height: 20px;
    }

    .tabla-importaciones-acciones {
      position: relative;
      min-width: 36px;
      padding-left: 8px;
      background-color: white;
    }

    .tabla-importaciones-dropdown {
      position: absolute;
      right: 0;
      top: calc(100% + 6px);
      min-width: 110px;
      background: white;
      border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
      border-radius: 10px;
      padding: 6px;
      z-index: 1000;
    }

    .tabla-importaciones-dropdown-item {
      border: 0;
      background: transparent;
      color: var(--bs-primary);
      padding: 6px 8px;
      border-radius: 6px;
    }

    .tabla-importaciones-dropdown-item:hover {
      background: rgba(var(--bs-primary-rgb), 0.08);
    }

    .tabla-importaciones-acciones-btn {
      color: rgba(var(--bs-primary-rgb), 0.6);
    }
  }

  .btn-danger {
    background-color: var(--rojo-400);
    border-color: var(--rojo-400);
    color: white;

    &:hover {
      background-color: var(--rojo-600);
      border-color: var(--rojo-700);
    }
  }

  @media screen and (max-width: 768px) {
    .hero-image {
      display: none;
    }
  }

  .title-rectangle {
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
  }

  .pago-seccion {
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
  }

  .pago-item {
    border-bottom: 1px solid rgba(var(--bs-primary-rgb), 0.2);

    &:not(:last-child) {
      padding-bottom: 20px;
    }

    &:last-child {
      border-bottom: 0;
    }
  }

  .pago-badge {
    border-radius: var(--bs-border-radius-lg);
    padding: 2px 4px;
  }

  .pago-item-fecha-label,
  .pago-item-fecha-valor {
    display: inline;
  }

  @media screen and (min-width: 769px) {
    .pago-item-izq {
      .pago-item-titulo {
        order: 1;
      }

      .pago-item-recibo {
        order: 2;
      }

      .pago-item-estado {
        order: 3;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .pago-item-cabecera {
      display: grid;
      grid-template-columns: auto minmax(0, 1fr) auto;
      align-items: start;
      column-gap: 16px;
      row-gap: 0;
      margin-left: 0;
      margin-right: 0;

      > [class*='col-'] {
        width: auto;
        max-width: none;
        padding: 0;
      }
    }

    .pago-item-izq {
      grid-column: 1;
      grid-row: 1;
      flex-direction: column;
      align-items: flex-start;
      align-self: start;
      gap: 8px;
    }

    .pago-item-titulo {
      order: 1;
    }

    .pago-item-estado {
      order: 2;
    }

    .pago-item-recibo {
      order: 3;
    }

    .pago-item-fecha {
      grid-column: 2;
      grid-row: 1;
      align-self: start;
      justify-self: start;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
    }

    .pago-item-fecha-label,
    .pago-item-fecha-valor {
      display: block;
      text-align: start;
    }

    .pago-item-importe {
      grid-column: 3;
      grid-row: 1;
      align-self: start;
      justify-self: end;
      text-align: end;
      white-space: nowrap;
    }
  }
</style>
